import eventFieldService from '@/api/eventModule/eventFieldServices'

export default {
  loadTable({ commit }, pageConfig) {
    return new Promise((resolve, reject) => eventFieldService
      .loadTable(pageConfig)
      .then(result => {
        commit('LOAD_LIST_EVENT_FIELDS', result.data.content)
        resolve(result)
      })
      .catch(err => reject(err)))
  },
  insertNew({ commit }, data) {
    return eventFieldService
      .insertNew(data)
      .then(result => result)
      .catch(error => error)
  },
  prepareToEditEventField({ commit }, data) {
    commit('PREPARE_TO_EDIT_EVENT_FIELD', data)
  },
  edit({ commit }, data) {
    return eventFieldService
      .edit(data)
      .then(result => result)
      .catch(error => error)
  },
  resetEventField({ commit }) {
    commit('RESET_EVENT_FIELD')
  },
  delete({ commit }, id) {
    return eventFieldService
      .delete(id)
      .then(result => result)
      .catch(error => error)
  },
}
